import React, {useEffect} from 'react'
import {useHistory} from 'react-router-dom'
import {LoadingState} from '../../components'
import {useAuth} from '../../stores/AuthStore'

/*
This is where we redirect to after Auth0 authentication.
We will use the auth/exchange endpoint to send our access_token to get the jwt legacy token.
If we get a good legacy token, then redirect to /albums
*/

export const CallbackView: React.FC<React.PropsWithChildren> = () => {
  const history = useHistory()
  const {error, authenticationStatus, loading} = useAuth()

  useEffect(() => {
    // If we are still loading, don't navigate
    if (loading) {
      return
    }

    // If there is an error, navigate to the auth error page
    if (error) {
      history.replace('/auth-error')
      return
    }

    // If we are authenticated with Auth0, navigate to the albums page
    if (
      authenticationStatus === 'idp_authenticated' ||
      authenticationStatus === 'authenticated'
    ) {
      history.replace('/albums')
    }
  }, [authenticationStatus, loading, error, history])

  return <LoadingState />
}
